var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ui-checkbox checkbox",class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"click":_vm.handleClick}}),_c('i',{class:{
    'v-icon':true,
    'fas fa-check-square':this.isChecked,
    'far fa-square':!this.isChecked
    },style:(_vm.colorState)}),_c('span',{staticClass:"label-wrapper"},[_vm._t("label",[_c('ui-label',{attrs:{"text":_vm.label,"helpTooltip":_vm.helpTooltip,"text-bold":false,"planLimits":_vm.planLimits}})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }